import { Heading } from '@hawkins/components';
import { QueryParamProvider } from 'use-query-params';
import { useReactRouter6Adapter } from '../../lib/ReactRouter6Adapter';
import { useCameras } from '../../domains/api/cameras';
import { CameraContext } from '../../domains/api/cameras/CameraContext';
import { AppShell } from '../../domains/shared/components/AppShell';
import { Header } from '../../domains/shared/components/Header';
import { AppContent } from '../../domains/shared/components/AppContent';
import { AppLoader } from '../../domains/shared/components/AppLoader';
import { ResponsiveErrorState } from '../../domains/shared/components/ResponsiveErrorState';
import { PageHeader } from '../../domains/shared/components/PageHeader';
import { CalculatorSelection } from '../../domains/pages/Calculators/components/CalculatorSelection';
import styles from '../../calculators.module.css';

const title = 'Production Tech Tools';

export const CalculatorsPage = () => {
  const { data: cameras, isLoading, error } = useCameras();
  const { history, location } = useReactRouter6Adapter();

  if (isLoading) {
    return (
      <AppShell>
        <Header name={title} />
        <AppContent>
          <AppLoader />
        </AppContent>
      </AppShell>
    );
  }

  if (error || !cameras) {
    return (
      <AppShell>
        <Header name={title} />
        <AppContent>
          <ResponsiveErrorState />
        </AppContent>
      </AppShell>
    );
  }

  return (
    <AppShell>
      <Header name={title} />
      <AppContent>
        <QueryParamProvider history={history} location={location as unknown as Location}>
          <CameraContext.Provider value={cameras}>
            <PageHeader>
              <Heading align="center" level={6}>
                Calculators
              </Heading>
              <Heading align="center" level={1}>
                A set of tools to help calculate Framing Resolution,
                Working Resolution, and Minimum Anamorphic Capture
                Resolution. These calculations are intended to serve
                only as a guide.
                <br />
                <br />
                To share your calculations, copy the unique URL
                generated.
              </Heading>
            </PageHeader>

            <div className={styles.calculatorContainer}>
              <CalculatorSelection />
            </div>
          </CameraContext.Provider>
        </QueryParamProvider>
      </AppContent>
    </AppShell>
  );
};

